import * as React from 'react';
import { fullContainer } from '../styles/styleObjects';

interface IProps {
    style?: React.CSSProperties;
    absolute?: boolean;
    onClick?(): void;
    onMouseOver?(): void;
    onMouseLeave?(): void;
}

export class FullContainer extends React.Component<IProps> {
    public render() {
        return (
            <div
                style={{
                    ...(this.props.absolute ? styles.absoluteFill : fullContainer),
                    ...this.props.style
                }}
                onClick={this.props.onClick}
                onMouseOver={this.props.onMouseOver}
                onMouseLeave={this.props.onMouseLeave}
            >
                {this.props.children}
            </div>
        );
    }
}

const styles = {
    absoluteFill: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/SharedComponents/FullContainer.tsx